import PaginatorComponent from "./Paginator.Component"
// import { Helpers } from "./Paginator.helpers"
import Actions from "./Paginator.actions"

export default {
    Component:PaginatorComponent,
    // Helpers,
    Actions
}